<template>
  <div>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" :fullscreen=true  :destroy-on-close="true" :append-to-body=true  :before-close="cancel">
      <div style="margin-bottom: 20px;margin-top: 30px">
        <el-button size="small" type="success" icon="el-icon-upload" @click="exportTo()">确认选择</el-button>
      </div>
      <div style="width:100%;">
        <w-table :columns="column" :table-data="tableData" @rowSelection="rowSelection"
                 @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
                 :table-col-check="{isShow:true,name:'SelectRecord2'}" ref="wMyTable"
                 :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true">
          <div slot="operation" slot-scope="{text,record}">
            <el-button size="small" type="success" icon="el-icon-upload" @click="exportTo(record)">确认选择</el-button>
          </div>

          <div slot="contractNumbers" slot-scope="{text,record,index}">
            <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
          </div>
          <div slot="status" slot-scope="{text,record}">
                       <span style="display: flex;align-items: center">
            <el-tag :type="getStatusColor(text,'tagType')"
                    :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
              {{getStatusColor(text,'name')}}</el-tag>
            <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look" :text="record['rejectionReason']"
                                 :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
            </w-ellipsis-and-look>
          </span>
          </div>
          <div slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
               style="padding: 8px; position: relative; z-index: 9999 !important;">
            <div style="padding: 15px 15px 0">
              <el-radio-group v-model="selectedKeys[0]">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-radio label='待审核'>待审核</el-radio>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-radio label='已通过'>已通过</el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-radio label='已驳回'>已驳回</el-radio>
                  </el-col>
                </el-row>
              </el-radio-group>
            </div>
            <div style="display: flex;padding: 15px">
              <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
              </a-button>
            </div>
          </div>
          <div slot="connectedFlag" slot-scope="{text,record}">
            <div v-if="record['requestNumberOfInvoices']>1">
              <el-tag v-if="text === 1" type="success">是</el-tag>
              <el-tag v-else-if="text === 0" type="danger">否</el-tag>
              <el-tag v-else type="primary">未知状态</el-tag>
            </div>
            <div v-else>
              <el-tag type="info">NA</el-tag>
            </div>
          </div>
          <div slot="sameDayFlag" slot-scope="{text,record}">
            <div v-if="record['requestNumberOfInvoices']>1">
              <el-tag v-if="text === 1" type="success">是</el-tag>
              <el-tag v-else-if="text === 0" type="danger">否</el-tag>
              <el-tag v-else type="primary">未知状态</el-tag>
            </div>
            <div v-else>
              <el-tag type="info">NA</el-tag>
            </div>
          </div>
          <div slot="filterFlag" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
               style="padding: 8px; position: relative; z-index: 9999 !important;">
            <div style="padding: 15px 15px 0">
              <el-radio-group v-model="selectedKeys[0]">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-radio label= '是' >是</el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-radio label= '否' >否</el-radio>
                  </el-col>
                </el-row>
              </el-radio-group>
            </div>
            <div style="display: flex;padding: 15px">
              <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
              </a-button>
            </div>
          </div>
        </w-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import ExFoldCell from "@/components/ExFoldCell.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import {record} from "@/utils/data/tableCol/record/record";
import {getRecordPage} from "@/api/dilivery/record";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import {getStatusColor} from "../../color";


export default {
  name: "SelectRecord",
  components: {ExFoldTable,ExFoldTableCell, ExFoldCell, TableHeadNote},
  mixins: [tableOperationMixin],
  props:['showDialog','type'],
  data() {
    return {
      title: '选择发票记录信息（日期提醒）',
      selectedRows: [],
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      }
    }
  },
  computed: {
    column() {
      let cols = record(this.searchConditionTag || {});
      return JSON.parse(JSON.stringify(cols))
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getStatusColor,
    //已提交表格选择框
    rowSelection(selectedRows) {
      this.selectedRows = selectedRows.map(item=>item.id)
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    // 获取发票表数据
    getData(type) {
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      let sendData = {
        "query#status.EQ":"SUCCESS"
      }
      sendData = this.getSearch(sendData)
      getRecordPage(params, sendData).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'status'){
          if(item.value === '待审核'){
            value = 'APPLYING'
          }else if(item.value === '已通过'){
            value = 'SUCCESS'
          }else{
            value = 'DEFEAT'
          }
        }else if(['connectedFlag','sameDayFlag'].includes(item.key)) {
          if(item.value === '是'){
            value = 1
          }else{
            value = 0
          }
        }
        sendData["query#" + item.key + ".LIKE"] = value
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    cancel(){
      this.$emit('record',[])
    },
    exportTo(row){
      let selectedRows = []
      if (row && row.id) {
        selectedRows.push(row.id)
        this.$emit('record',selectedRows)
      } else {
        selectedRows = this.selectedRows
        if (selectedRows.length > 0) {
          if(this.type === 'mail'){
            this.$emit('record',selectedRows)
          }else {
            if(selectedRows.length > 1){
              this.$messageUi.error('仅能选择一条发票记录')
            }else{
              this.$emit('record',selectedRows)
            }
          }
        } else {
          this.$messageUi.error('请选择发票记录')
        }
      }
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}

</style>
